import {useInvertedSurface} from '@hconnect/common/styles'
import {TimeZone} from '@hconnect/uikit'
import {DateRangePicker} from '@hconnect/uikit/src/lib2'
import {SelectionItem} from '@hconnect/uikit/src/lib2/components/simpleDatePicker/types'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'

type Props = {
  timeRangeParam?: string
  onTimeRangeParamChange?: (timeRange: string) => void
  timezone: TimeZone
  selectionItems: SelectionItem<string>[]
  label?: string
  dataTestId?: string
}

export const DateRangeFilter = ({
  timeRangeParam,
  onTimeRangeParamChange,
  timezone,
  selectionItems,
  label,
  dataTestId
}: Props) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const inverted = useInvertedSurface()

  return (
    <DateRangePicker
      timeRangeParam={timeRangeParam}
      onTimeRangeParamChange={onTimeRangeParamChange}
      singleDateSwitchLabel={t('quickSelection.pickSingleDate')}
      selectionItems={selectionItems}
      timezone={timezone}
      label={label}
      dataTestId={dataTestId}
      isContrastMode={inverted}
      withForm={true}
    />
  )
}
